SC.purchase_series = (function () {  
  var api = {};

  var init = function init() {
    handlers();
    filterRegionDropdown();
    changeRegionSeries();
    getSeriesGrid();
    changeSeriesMenuHandlers();
    setBodyClassBubblerByMenuActived();
  };
    // Hide regions based on current country
  var filterRegionDropdown = function filterRegionDropdown() {
    var currentCountryIso = $('.find-a-class .active-region').attr('data-country-iso');

    $('.change-region-container .region-select-row li a[data-country-iso!="' + currentCountryIso + '"]')
      .slice(1)
      .parent('li')
      .remove();
  };

  // Update the available series with an AJAX call if user clicks new region in dropdown
  var getSeriesGrid = function getSeriesGrid() {
    $('.credits-page .region-select-row a').on('click', function (e) {
      e.preventDefault();
      // Get the region and the current active menu on the page
      var $selectedRegion = $(this);
      var regionId = $selectedRegion.data('id');
      var activeMenu = $('.buy-classes-container').data('menu');
      var url = '/series/json/' + regionId + '/' + '?active-menu=' + activeMenu;

      $.ajax({
        type: 'get',
        url: url,
        dataType: 'json',
        success: function (data) {
          var changeRegionBtn = document.getElementById('region_button');
          var $regionLinks = $('.region-select-row a');
          var $amenities = $('#amenities-shoes');

          // Update usable regions and purchasable series
          $('.transfer-info').html(data.usable_regions);
          $('.cycle-series-container .class-packages').html(data.purchasable_cycle_series);
          if (data.purchasable_renewable_series) {
            $('.cycle-series-container .renewable-packages').html(data.purchasable_renewable_series);
            $('.cycle-series-container #series-renew').show();
            $('.series-renew-quicklink').show();
          } else {
            $('.cycle-series-container .renewable-packages').html('');
            $('.cycle-series-container #series-renew').hide();
            $('.series-renew-quicklink').hide();
          }

          var isVegas = (regionId === 25);
          // Toggles class on Shoe amenities tool tip in Las Vegas region.
          if (isVegas) {
            $amenities.addClass('visible');
          } else {
            $amenities.removeClass('visible');
          }

          // Update the active menu on the container
          $('.buy-classes-container').data('menu', data.active_menu);

          // Get the target by the current menu from the return data (Use this instead of activeMenu in case no Annex tab)
          var target = $('.series-tab-header' + "[data-menu='" + data.active_menu + "']");
          var seriesContainerName = data.active_menu + '-series-container';

          changeSeriesMenu(target, seriesContainerName);

          // Change the series bubbles state if you are changing the series menu
          setBodyClassBubblerByMenuActived();

          // UI update selected region and close menu
          $('.change-region-series .region').html($selectedRegion.html());
          $regionLinks.removeClass('active');
          $regionLinks.removeAttr('aria-selected');
          $selectedRegion.addClass('active');
          $selectedRegion.attr('aria-selected', 'true');
          $('.region-cc').removeClass('block');
          changeRegionBtn.focus();
          changeRegionBtn.setAttribute('aria-expanded', 'false');
        },

        error: function () {
          confirmation(null, 'oops! an error occurred while submitting your request. try that again!');
        }
      });
    });
  };

  // Switch from current active series menu to the selected Activity (i.e. Annex)
  var changeSeriesMenuHandlers = function changeSeriesMenuHandlers() {
    var $buyClassesContainer = $('.buy-classes-container');
    var opacityMid  = { 'opacity': 0.54 };
    var opacityFull = { 'opacity': 1 };

    var mouseEnter = function mouseEnter(e) {
      $(e.currentTarget).css(opacityMid);
      $('.series-tab-header.active span').css(opacityMid);
    };

    var mouseLeave = function mouseLeave(e) {
      $(e.currentTarget).css(opacityFull);
      $('.series-tab-header.active span').css(opacityFull);
    };

    enquire.register('screen and (min-width: 1024px)', {
      // Triggered when a media query matches.
      match: function () {
        $buyClassesContainer.on({mouseenter: mouseEnter, mouseleave: mouseLeave}, '.cycle-active');

        $buyClassesContainer.on('mouseenter', '.series-tab-header', function (e) {
          var $currentTarget = $(e.currentTarget);
          $currentTarget.children('span').css(opacityMid);

          if ($currentTarget.hasClass('active')) {
            $('.active-tab').css(opacityMid);
          }
        });

        $buyClassesContainer.on('mouseleave', '.series-tab-header', function (e) {
          var $currentTarget = $(e.currentTarget);
          $currentTarget.children('span').css(opacityFull);

          if ($currentTarget.hasClass('active')) {
            $('.active-tab').css(opacityFull);
          }
        });
      },

      // Triggered when the media query transitions
      unmatch: function () {
        $buyClassesContainer.off('mouseenter mouseleave', '.cycle-active');
        $buyClassesContainer.off('mouseenter mouseleave', '.series-tab-header');
      }
    });

    $buyClassesContainer.on('click keydown', '.series-tab-header', function (e) {
      if (e.type === 'keydown' && e.key !== 'Enter') {
        return;
      }

      var $currentTarget = $(e.currentTarget);
      var activeMenu = $('.buy-classes-container').data('menu');
      var clickedMenu = $currentTarget.data('menu');
      var activeTabClass = activeMenu + '-active';
      var clickedTabClass = clickedMenu + '-active';
      var seriesContainerName = clickedMenu + '-series-container';

      $('.' + activeTabClass).removeClass(activeTabClass).addClass(clickedTabClass);
      changeSeriesMenu(e.currentTarget, seriesContainerName);
      $('.buy-classes-container').data('menu', clickedMenu);

      setBodyClassBubblerByMenuActived();
    });
  };

  var changeSeriesMenu = function changeSeriesMenu(currentTarget, seriesContainerName) {
    // Remove active class from all tabs and add active to this tab
    $('.series-tab-header').removeClass('active').attr('aria-selected', 'false');
    $(currentTarget).addClass('active').attr('aria-selected', 'true');

    // Remove active class from current class packages and add to current page
    $('.series-container').removeClass('active').hide();
    $('.' + seriesContainerName).addClass('active').show();
  };

  var hoverInfo = function ($this, status) {
    if (status === 'show') {
      $this.siblings('.credits-additional-info-desktop').addClass('block');
    } else {
      $this.children('.credits-additional-info-desktop').removeClass('block');
    }
  };

  var changeRegionSeries = function () {
    var changeRegionBtn = document.getElementById('region_button');
    var regionList = document.getElementsByClassName('region-cc')[0];

    var regionBtnEvent = function (e) {
      e.stopPropagation();
      e.preventDefault();

      if (regionList.classList.contains('block')) {
        regionList.classList.remove('block');
        regionList.setAttribute('aria-hidden', 'true');
        changeRegionBtn.setAttribute('aria-expanded', 'false');
      } else {
        regionList.classList.add('block');
        regionList.removeAttribute('aria-hidden');
        changeRegionBtn.setAttribute('aria-expanded', 'true');

        setTimeout(function () {
          regionList.getElementsByTagName('a')[1].focus();
        }, 0);
      }
    };

    changeRegionBtn.addEventListener('click', function (e) {
      regionBtnEvent(e);
    });

    regionList.addEventListener('focusout', function (e) {
      if (regionList.contains(e.relatedTarget)) {
        return;
      }

      setTimeout( function () {
        regionList.classList.remove('block');
        changeRegionBtn.setAttribute('aria-expanded', 'false');
        regionList.setAttribute('aria-hidden', 'true');
      }, 100);
    });

    $('html').click(function () {
      regionList.classList.remove('block');
      regionList.setAttribute('aria-hidden', 'true');
      changeRegionBtn.setAttribute('aria-expanded', 'false');
    });
  };

  // Basic handlers mostly taken from soulcycle.js
  var handlers = function handlers() {
    var $seriesContainer = $('.buy-classes-container');

    $seriesContainer.on('click keypress', '.add-series-form .form-button', function (e) {
      if (e.type === 'keypress' &&  e.key !== 'Enter') {
        return;
      }

      var $form = $(this).closest('form');
      var $productInfo = $form.find('#product-info');
      var seriesName = String($productInfo.data('series-name'));
      var productName = seriesName === '1' ? 'A single class.' : 'A set of ' + seriesName + ' classes.';
      var baseSku = $productInfo.data('series-id');
      var sku = SC.utils.getSku('Series', baseSku, seriesName);
      var attrs = {'Base Sku': baseSku};
      var unitPrice = $productInfo.data('series-price').substr(1);
      var quantity = $productInfo.find('[name="quantity"]').first().val();
      var category = $productInfo.data('analytics-category');
      var product = SC.analytics.mp.createProduct(
        productName,
        sku,
        unitPrice,
        quantity,
        category,
        attrs
      );

      /**
       * MParticle and GA send events - Add to Cart
       */
      SC.analytics.mp.setCurrencyCode($productInfo.data('currency-code'));
      SC.analytics.mp.logProductEvent('AddToCart', product, {'Location': 'Series'});

      // Submit the Add To Cart Form
      $form.submit();
    });

    $seriesContainer.on('mouseenter', '.more-info-icon', function (e) {
      var $this = $(e.currentTarget);
      hoverInfo($this, 'show');
    });

    $seriesContainer.on('mouseleave', '.more-info', function (e) {
      var $this = $(e.currentTarget);
      hoverInfo($this, 'hide');
    });

    $seriesContainer.on('click', '.more-info-icon', function (e) {
      var $this = $(e.currentTarget);
      hoverInfo($this, 'show');
    });

    $seriesContainer.on('click', '.buy-series-close-button', function (e) {
      e.stopPropagation();
      $(this).parent('.credits-additional-info-desktop').removeClass('block');
    });

    $seriesContainer.on('click', '.region-select-row li a', function (e) {
      /**
       * mParticle sendEvent - Click New Region - Series Page
       * Sends an mParticle event with a custom GA label.
       */
      var region = $(e.currentTarget).data('region-name');
      var eventData = {
        'Location': 'Series',
        'Region Name': region
      };
      SC.analytics.mp.sendEvent('Click New Region', 'navigation', eventData, 'Series');
    });
  };

  var setBodyClassBubblerByMenuActived = function setBodyClassBubblerByMenuActived() {
    var prefixClass = 'series-bubbler-';
    var currentMenuActived = $('.buy-classes-container').data('menu');

    $('body').removeClass(prefixClass + 'annex')
      .removeClass(prefixClass + 'cycle')
      .addClass(prefixClass + currentMenuActived);
  };

  init();
  return api;
})();
